module.exports = __webpack_public_path__ + "img/banner-right.82216762.svg";